import React from 'react';
import './StaticPage.css';

const Impressum = ({ onBack }) => {
    return (
        <div className="static-page">
            <div className="static-content">
                <div className="static-header">
                    <img
                        src={`${process.env.PUBLIC_URL}/main.png`}
                        alt="SRR Logo"
                        className="static-logo"
                    />
                    <div className="static-title">
                        <span className="static-title-top">Simple</span>
                        <span className="static-title-bottom">RefiReg</span>
                    </div>
                </div>

                <div className="static-text-container">
                    <h1>Impressum</h1>

                    <p>
                        <strong className="company-name">sstyle.org</strong><br />
                        <span className="company-slogan">it (re)engineering</span>
                        <span className="company-owner">Inhaber: Max Becker</span>
                        <br />
                        Hubertusstr. 27c<br />
                        15537 Grünheide (Mark)<br />
                        <br />
                        E-Mail: info@sstyle.org<br />
                        Tel: &nbsp;+49 3362 888 422 8<br />
                        Fax: +49 3362 888 422 9
                    </p>
                </div>

                <button
                    className="static-back-link"
                    onClick={onBack}
                >
                    Zurück
                </button>
            </div>
        </div>
    );
};

export default Impressum;

